import { Tour } from 'antd5';
import React, { Component } from 'react';


class TourItem extends Component {

    render() {

        const steps = this.props.steps.map((step) => {
            return {
                ...step,
                nextButtonProps: {
                    children: 'Siguiente',
                },
                prevButtonProps: {
                    children: 'Anterior',
                },
            }
        })

        const nuevasProps = {
            ...this.props,
            steps: steps,
            disabledInteraction: this.props.disabledInteraction === undefined ? true : this.props.disabledInteraction,
        }

        return (
            <Tour {...nuevasProps}/>
        )
    }

}



export default TourItem;